import messages from 'containers/QuickOrder/messages';
import React, { MouseEvent } from 'react';
import styled from 'styles/styled-components';
import translations from 'translations';
import { WarningIcon } from './icons';

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Box = styled.div`
  position: relative;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  width: 480px;
  max-width: calc(100vw - 32px);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
  color: #4b5563;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

const Title = styled.h2`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #111827;
  margin: 0;
  text-align: center;
`;

const Body = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #303643;
  margin: 0;
  text-align: center;
`;

const Footer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`;

const FooterButton = styled.button<{ variant: 'cancel' | 'confirm' }>`
  font-family: 'Maven Pro';
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 44px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e5e7eb;
  color: ${({ variant }) => (variant === 'confirm' ? '#e2483c' : '#111827')};

  &:hover {
    background: #f9fafb;
  }
`;

interface LeaveConfirmModalProps {
  title: string;
  body: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const LeaveConfirmModal = ({ title, body, confirmLabel, onCancel, onConfirm }: LeaveConfirmModalProps) => (
  <Overlay onClick={onCancel}>
    <Box onClick={(e: MouseEvent) => e.stopPropagation()}>
      <CloseButton onClick={onCancel} aria-label="close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path d="M3 3L13 13M13 3L3 13" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      </CloseButton>
      <IconWrapper>
        <WarningIcon />
      </IconWrapper>
      <Title>{title}</Title>
      <Body>{body}</Body>
      <Footer>
        <FooterButton variant="cancel" onClick={onCancel}>
          {translations(messages.leaveConfirmCancel)}
        </FooterButton>
        <FooterButton variant="confirm" onClick={onConfirm}>
          {confirmLabel}
        </FooterButton>
      </Footer>
    </Box>
  </Overlay>
);

export default LeaveConfirmModal;
